import { render, staticRenderFns } from "./OperationalScreen_WebshopOverview.vue?vue&type=template&id=3f64a1fa&scoped=true&"
import script from "./OperationalScreen_WebshopOverview.vue?vue&type=script&lang=js&"
export * from "./OperationalScreen_WebshopOverview.vue?vue&type=script&lang=js&"
import style0 from "./OperationalScreen_WebshopOverview.vue?vue&type=style&index=0&id=3f64a1fa&lang=scss&scoped=true&"
import style1 from "./OperationalScreen_WebshopOverview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f64a1fa",
  null
  
)

export default component.exports